import { computed, ref, watch } from "vue";
import nl from "./locales/nl";
import en from "./locales/en";

export type Locale = "nl" | "en";
export type Messages = typeof nl;

const STORAGE_KEY = "tekdam-locale";

const dictionaries: Record<Locale, Messages> = { nl, en };

const stored = typeof localStorage !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;
const locale = ref<Locale>(stored === "en" ? "en" : "nl");

document.documentElement.lang = locale.value;

watch(locale, (value) => {
  localStorage.setItem(STORAGE_KEY, value);
  document.documentElement.lang = value;
});

const t = computed(() => dictionaries[locale.value]);

export function useI18n() {
  const setLocale = (value: Locale) => {
    locale.value = value;
  };
  return { locale, t, setLocale };
}
